import gql from "graphql-tag";

export const OPTIONS_PENDING_APPROVAL_QUERY = gql`
  query OptionsPendingApproval($count: Int!) {
    moderationOptions: optionsPendingApproval(count: $count) {
      id
      resolveAction
      hasBackground
      containsLogo

      image {
        id
        nesImageId
        status
        originalUrl
        imageUrl
      }
    }
  }
`;

export {
  OptionsPendingApproval,
  OptionsPendingApprovalVariables,
  OptionsPendingApproval_moderationOptions as IModerationOption,
  OptionsPendingApproval_moderationOptions_image as IOptionImage
} from "~/graphql/types";



// WEBPACK FOOTER //
// ./src/graphql/queries/optionApproval/optionsPendingApproval.ts